export default [
    {
        label: 'Casado',
        value: 'married'
    }, {
        label: 'Soltero',
        value: 'single'
    }, {
        label: 'Convivencia',
        value: 'concubinage'
    }
];
